import * as React from "react";
const SvgViewList = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", stroke: "currentColor", ...props }, /* @__PURE__ */ React.createElement("path", { strokeLinecap: "round", strokeWidth: 2, d: "M3 5h18M3 12h18M3 19h18" }));
export default SvgViewList;
